import SecondSection from "../сomponents/SecondSection/SecondSection";
import ThirdSection from "../сomponents/ThirdSection/ThirdSection";
import ForthSection from "../сomponents/FourthSection/FourthSection";
import FifthSection from "../сomponents/FifthSection/FifthSection";
import SixthSection from "../сomponents/SixthSection/SixthSection";

const SectionArray = [
  SecondSection,
  ThirdSection,
  ForthSection,
  FifthSection,
  SixthSection,
];

export default SectionArray;
